import { render, staticRenderFns } from "../../components/shared/contacts/RemoveContactTemplate.html?vue&type=template&id=595eda68&scoped=true&"
import script from "./RemoveContactModal.vue?vue&type=script&lang=js&"
export * from "./RemoveContactModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveContactModal.vue?vue&type=style&index=0&id=595eda68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595eda68",
  null
  
)

component.options.__file = "RemoveContactModal.vue"
export default component.exports